<template>
  <div style="height: 100%">
    <grid ref="grid" :config="gridConfig" class="grid-forwarders-shipper"/>
    <modal-new
      :config="{id: gridConfig.id, api: 'Forwarders/Get/'}"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import gridConfig from './GridConfig.json'
import { waitValue } from '@/utils/promises'

export default {
  name: 'ForwardersShipper',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'modal-new': () => import(/* webpackChunkName: 'Shippers' */ './ModalNew')
  },
  props: {
    disabled: { type: Boolean, required: true },
    currentID: { required: true }
  },
  watch: {
    'currentID': {
      immediate: true,
      handler () {
        this.getGrid()
          .then((grid) => {
            if (this.currentID) {
              grid.model.store.get.filters = `shipperID == ${this.currentID}`
              grid.loadData()
            }
          })
      }
    }
  },
  data () {
    return {
      gridConfig: gridConfig,
      shipperID: null
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs.grid)
    }
  }
}
</script>
<style lang="stylus">
  .grid-forwarders-shipper {
    &.grid-side{
      .grid-wrapper{
        margin 0
        padding 0
        border none
        border-radius none
      }
    }
  }
</style>
